// extracted by mini-css-extract-plugin
export default {"bullet":"Vw52i8d0"};